<template>
  <div class="warningList">
    <div class="warningBox">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>预警列表</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <div class="warningMain">
        <div class="warningSearch">
          <ul class="textAlign ft14">
            <li class="contractsBox">
              <input type="text" placeholder="合同名称" v-model="contractName" class="contractName">
            </li>
            <li class="createdBox">
              <el-date-picker
                v-model="createdTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="创建时间"
              ></el-date-picker>
            </li>
            <li class="informBox ft14">
              <el-select v-model="notification" placeholder="通知方式" size="mini">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </li>
            <li>
              <span class="searchBtn" @click="searchFn"></span>
            </li>
            <li class="checboxBox ft14">
              <el-checkbox class="chekboxBtn" v-model="showOverdue" @change="chekboxBtn">隐藏已过期提醒</el-checkbox>
            </li>
            <router-link to="add" tag="li" class="addWarning ft12">新增预警</router-link>
          </ul>
        </div>
        <div class="warningCon">
          <el-table :data="listsTable" border style="width: 100%">
            <template slot="empty">
              <img class="data-pic" src="../../../assets/images/H5/null.png" alt>
              <br>暂无数据
            </template>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column prop="name" label="预警名称"></el-table-column>
            <el-table-column prop="contractName" label="合同名称"></el-table-column>
            <el-table-column prop="mail" label="消息接收方">
              <template slot-scope="scope">
                <div>
                  <p v-for="user in scope.row.userNameList" :key="user">{{user}}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="warnTime" label="预警时间"></el-table-column>
            <el-table-column prop="eventName" label="预警事件"></el-table-column>
            <el-table-column label="通知方式">
              <template slot-scope="scope">
                <div>
                  <span>{{getNotifyType(scope.row.messageType)}}</span>
                  <!-- <span v-if="scope.row.messageType=='1,3'">短信,站内通知</span>
                  <span v-if="scope.row.messageType=='1,2'">短信,邮件</span>
                  <span v-if="scope.row.messageType=='2,3'">邮件,站内通知</span>
                  <span v-if="scope.row.messageType=='1,2,3'">短信,邮件,站内通知</span>-->
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                  <span @click="delFn(scope.row.id)">
                    <img src="../../../assets/images/warning/common_icon_btn_n5.png">删除
                  </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-pagination
        v-if="showPagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <Dialog
      :visible="dialogVisible"
      :dialogTitle="'消息提示'"
      v-on:closeDialog="closeDialog"
      :width="'300px'"
    >
      <div slot="dialog">
        <div class="messgaInfo textAlign ft14">
          <p>是否删除这条预警</p>
          <p>
            <span @click="cancelFn">取消</span>
            <span @click="trueDelFn">确定</span>
          </p>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import $ from "jquery";
import Dialog from "@common/Dialog.vue";
import BaseApi from "@lib/baseApi.js";
import breadcrumb from "@common/Breadcrumb.vue";
import {mapState} from "vuex"
export default {
  data() {
    return {
      delNum: "",
      contractWarnIds: "",
      currentPage: 1, //默认第一页
      total: 10, //总条数
      pageSizes: [10, 20, 50, 100, 200], //每页展示多少条
      pageSize: 10, //默认第一页展示10条
      dialogVisible: false,
      showOverdue: false,
      status: "1",
      contractName: "", //合同名称
      createdTime: "", //创建日期
      notification: "", //通知方式
      tabheadList: [
        "创建时间",
        "预警名称",
        "合同名称",
        "消息接收方",
        "预警时间",
        "预警事件",
        "通知方式",
        "操作"
      ],
      listsTable: [], //返回来的结果
      options: [
        {
          value: "1",
          label: "短信通知"
        },
        {
          value: "2",
          label: "邮件通知"
        },
        {
          value: "3",
          label: "站内通知"
        },
        {
          value: "",
          label: "所有通知"
        }
      ],
      showPagination: false
    };
  },
  mounted() {
    var this_1 = this;
    this_1.init();
  },
  methods: {
    init: function() {
      var this_1 = this;
      var queryStr = {
        contractName: this.contractName,
        createTime: this.createdTime,
        noticeType: this.notification,
        showOverdue: this.status,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      if (this.contractName) queryStr.contractName = this.contractName;
      if (this.createTime) queryStr.createTime = this.createTime;
      if (this.notification) queryStr.noticeType = this.notification;
      BaseApi.createRpcToken(" /warn/contractWarnList", queryStr)
        .then(
          data => {
            if (data.datas.list != "") {
              this.listsTable = data.datas.list;
              this.total = data.datas.totalRow;
              if (data.datas.totalRow > 10) {
                this.showPagination = true;
              } else {
                this.showPagination = false;
              }
            }
          },
          data => {
            console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    getNotifyType(type) {
      let arrObject = {
        "1": "短信",
        "2": "邮件",
        "3": "站内通知"
      };
      let typeArr = type.split(",");
      let transFormArr = [];
      typeArr.forEach(value => {
        transFormArr.push(arrObject[value]);
      });
      return transFormArr.join("，");
    },
    searchFn() {
      var this_1 = this;
      this_1.init();
    },
    chekboxBtn() {
      if (this.showOverdue == false) {
        this.status = "1";
      } else {
        this.status = "2";
      }
      this.init();
    },
    delFn(id) {
      this.contractWarnIds = id;
      this.dialogVisible = true;
    },
    closeDialog(data) {
      this.dialogVisible = data;
    },
    handelClick() {
      this.dialogVisible = true;
    },
    trueDelFn() {
      var this_1 = this;
      var queryStr = {
        contractWarnIds: this.contractWarnIds
      };
      BaseApi.createRpcToken(" /warn/delete", queryStr, "post")
        .then(
          data => {
            this.init();
            this.dialogVisible = false;
          },
          data => {
            console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    cancelFn() {
      this.dialogVisible = false;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.init();
    }
  },
  components: {
    Dialog,
    breadcrumb
  },
  computed:{
    ...mapState(['currentInfo']),
  },
   watch:{
    "currentInfo"(data){
       this.init()
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.warningList {
  background: #eaedf1;
  width: 100%;
  box-sizing: border-box;
  overflow: scroll;
  .warningBox {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: scroll;
    .warningMain {
      width: 100%;
      padding-top: 30px;
      .warningSearch {
        width: 100%;
        overflow: hidden;
        ul {
          li {
            float: left;
            margin-right: 10px;
            border: 1px solid #e4e8eb;
            border-radius: 3px;
            height: 30px;
            line-height: 30px;
            input {
              width: 100%;
              height: 100%;
            }
            input::-ms-input-placeholder {
              text-align: center;
            }
            input::-webkit-input-placeholder {
              text-align: center;
            }
          }
          .contractsBox {
            width: 180px;
            padding: 0 10px;
          }
          .createdBox {
            width: 130px;
            border: 1px solid #e4e8eb;
            border-radius: 3px;
            height: 30px;
            input {
              width: 130px;
              line-height: 30px;
              border: none;
              padding-right: 20px;
            }
            .el-input__prefix {
              top: -5px;
            }
          }
          .addWarning {
            float: right;
            cursor: pointer;
          }
          .informBox {
            border: none;
            .el-select {
              width: 130px;
              height: 30px;
              .el-input {
                height: 100%;
              }
            }
            .el-input__inner {
              padding: 0 40px;
            }
          }
          .checboxBox {
            border: none;
            color: #969696;
            .chekboxBtn {
              width: 12px;
              height: 12px;
              margin-right: 10px;
              .el-checkbox__input {
                line-height: 12px;
              }
              .el-checkbox__input.is-checked .el-checkbox__inner,
              .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                border-color: #e88078;
                background: #e88078;
              }
              .el-checkbox__inner:hover {
                border-color: #e88078;
              }
              .el-checkbox__input.is-checked + .el-checkbox__label {
                color: #e88078;
              }
            }
          }
          .addWarning {
            width: 100px;
            border: 1px solid #e29999;
            color: #e29999;
            margin: 0;
          }
          .addWarning:hover {
            background: #a5303d;
            color: #fff;
          }
          .searchBtn {
            display: block;
            width: 30px;
            height: 30px;
            cursor: pointer;
            background: url("../../../assets/images/warning/search_icon_nor.png");
          }
          .searchBtn:hover {
            background: url("../../../assets/images/warning/search_icon_pre.png");
          }
        }
      }
      .warningCon {
        width: 100%;
        margin-top: 10px;
        height: 100%;
        table {
          width: 100%;
          height: 100%;
          table-layout: auto;
          th:nth-child(1),
          td:nth-child(1) {
            width: 11%;
          }
          th:nth-child(2),
          td:nth-child(2) {
            width: 15%;
          }
          th:nth-child(3),
          td:nth-child(3) {
            width: 15%;
          }
          th:nth-child(4),
          td:nth-child(4) {
            width: 18%;
          }
          th:nth-child(5),
          td:nth-child(5) {
            width: 11%;
          }
          th:nth-child(6),
          td:nth-child(6) {
            width: 9%;
          }
          th:nth-child(7),
          td:nth-child(7) {
            width: 10%;
          }
          th:nth-child(8),
          td:nth-child(8) {
            width: 11%;
            span {
              display: inline-block;
              height: 100%;
              img {
                width: 11px;
                height: 14px;
                margin-right: 5px;
              }
            }
          }
          td:nth-child(8) {
            cursor: pointer;
            .cell{
              p{
                  display: flex;
                  align-items: center;
                  justify-content: center;
            }
            }
          }
          tr {
            height: 32px;
            th {
              padding: 0;
              text-align: center;
              background: #f9f9f9;
            }
            td {
              text-align: center;
              padding: 0;
              img {
                vertical-align: middle;
              }
            }
          }
          thead {
            background: #f9f9f9;
            color: #505050;
            td {
              height: 48px;
            }
          }
          .cell {
            width: 100%;
          }
          tbody {
            height: 100%;
            width: 100%;
            overflow: scroll;
            tr {
              color: #969696;
              p {
                width: 100%;
                box-sizing: border-box;
                white-space: pre-wrap;
              }
            }
          }
        }
      }
    }
  }
  .el-dialog {
    width: 400px !important;
    .header {
      height: 40px;
    }
    .messgaInfo {
      width: 100%;
      padding-bottom: 32px;
      p:nth-child(1) {
        padding: 58px;
        color: #646464;
      }
      p:nth-child(2) {
        span {
          display: inline-block;
          width: 100px;
          height: 32px;
          line-height: 32px;
          border: 1px solid #c8c8c8;
        }
        span:nth-child(1) {
          margin-right: 40px;
        }
        span:hover {
          background-color: #D81212;
          color: #fff;
        }
      }
    }
  }
  .el-pagination {
    float: right;
    margin: 20px 0;
  }
}
</style>
